import { render, staticRenderFns } from "./HistoricalClientFilter.vue?vue&type=template&id=3861d020&scoped=true&"
import script from "./HistoricalClientFilter.vue?vue&type=script&lang=js&"
export * from "./HistoricalClientFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3861d020",
  null
  
)

export default component.exports